import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import ClassDetail from '@/components/ClassDetail.vue';
const classesModule = namespace('classes');
let CharacterClassDetail = class CharacterClassDetail extends Vue {
    created() {
        this.fetchClasses();
    }
    get title() {
        return this.className + Vue.prototype.$titleSuffix;
    }
    get classData() {
        return this.classes.find(({ name }) => name === this.className);
    }
};
__decorate([
    classesModule.State
], CharacterClassDetail.prototype, "classes", void 0);
__decorate([
    classesModule.Action
], CharacterClassDetail.prototype, "fetchClasses", void 0);
__decorate([
    Prop(String)
], CharacterClassDetail.prototype, "className", void 0);
CharacterClassDetail = __decorate([
    Component({
        components: {
            ClassDetail
        }
    })
], CharacterClassDetail);
export default CharacterClassDetail;
